const group = {
	state: {
		activeGroup: {}
	},
	mutations: {
		setActiveGroup(state, activeGroup) {
			state.activeGroup = activeGroup;
		}
	},
	getters: {
		getActiveGroup(state) {
			return state.activeGroup;
		}
	}
}

export default group;